export default [
  {
    path: '/shaanxi',
    name: "shaanxi",
    component: () => import('@/views/shaanxi/start.vue'),
    children: [
      {
        path: 'videoflowbag',
        name: "videoflowbag",
        component: () => import('@/views/shaanxi/videoflowbag.vue'),
        meta: {
          title: '首月免费权益包'
        }
      },
      {
        path: 'videoflow',
        name: "videoflow",
        component: () => import('@/views/shaanxi/videoflow.vue'),
        meta: {
          title: '首月免费权益包'
        }
      },
      {
        path: 'confirmdecvideoflow',
        name: "confirmdecvideoflow",
        component: () => import('@/views/shaanxi/confirmdecvideoflow.vue'),
        meta: {
          title: '首月免费权益包'
        }
      },
      {
        path: 'decvideoflow',
        name: "decvideoflow",
        component: () => import('@/views/shaanxi/decvideoflow.vue'),
        meta: {
          title: '首月免费权益包'
        }
      },
      {
        path: 'success',
        name: "videoflowbagSuccess",
        component: () => import('@/views/shaanxi/success.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'commonSuccess',
        name: "videoflowbagCommonSuccess",
        component: () => import('@/views/shaanxi/commonSuccess.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'janvideoflow',
        name: "sxJanVideoflow",
        component: () => import('@/views/shaanxi/janvideoflow.vue'),
        meta: {
          title: '陕西移动用户专享'
        }
      },
      {
        path: 'confirmjanvideoflow',
        name: "sxConfirmJanVideoflow",
        component: () => import('@/views/shaanxi/confirmjanvideoflow.vue'),
        meta: {
          title: '陕西移动用户专享'
        }
      },
      {
        path: 'febvideoflow',
        name: "sxFebVideoflow",
        component: () => import('@/views/shaanxi/febvideoflow.vue'),
        meta: {
          title: '陕西移动用户专享'
        }
      },
      {
        path: 'confirmfebvideoflow',
        name: "sxFebVideoflow",
        component: () => import('@/views/shaanxi/confirmfebvideoflow.vue'),
        meta: {
          title: '陕西移动用户专享'
        }
      }
    ]
  }
]